<template>
  <div class="app-container">
    <div class="header">
      <div class="search">
        <!-- <el-date-picker class="search-picker" v-model="newsDate" type="date" placeholder="选择日期" /> -->
        <el-input
          class="search-input"
          v-model="formInline.title"
          placeholder="请输入要查询关键字"
        ></el-input>
        <el-select
          class="search-select"
          v-model="formInline.classType"
          placeholder="选择分类"
        >
          <el-option label="查询所有" :value="0"></el-option>
          <el-option label="项目动态" :value="1"></el-option>
          <el-option label="热点新闻" :value="2"></el-option>
        </el-select>
        <el-select
          class="search-select"
          v-model="formInline.status"
          clearable
          placeholder="选择状态"
        >
          <el-option label="编辑中" :value="1"></el-option>
          <el-option label="已发布" :value="2"></el-option>
        </el-select>
        <el-button icon="el-icon-search" @click="onSearch" size="small"
          >查询</el-button
        >
        <el-button size="small" @click="onRefresh" icon="el-icon-refresh"
          >刷新</el-button
        >
      </div>
      <div>
        <PermissionsBtn
          :icon="'el-icon-download'"
          :permissionName="'_Export'"
          :btnType="'primary'"
          :downloadUrl="'/newsadmin/News/downLoad'"
          :checkList="checkList"
          :form="formInline"
        ></PermissionsBtn>
        <el-button
          size="small"
          icon="el-icon-plus"
          @click="onAdd"
          type="primary"
          v-if="roleList[path].includes('_Add')"
          >新增</el-button
        >
        <el-button
          size="small"
          icon="el-icon-delete"
          @click="onRemove"
          type="danger"
          v-if="roleList[path].includes('_Delete')"
          >删除</el-button
        >
      </div>
      <!-- <el-dropdown>
                <el-button type="primary">
                    更多菜单<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="onGoto()">新闻分类管理</el-dropdown-item>
                    <el-dropdown-item @click.native="onChange(1)">开启新闻</el-dropdown-item>
                    <el-dropdown-item @click.native="onChange(2)">关闭新闻</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown> -->
    </div>

    <!-- <div  class="content"> -->

    <el-table
      v-loading="listLoading"
      height="750"
      :data="tableData"
      element-loading-text="Loading"
      fit
      highlight-current-row
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column align="center" width="50" label="编号">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>

      <el-table-column label="标题" align="center">
        <template slot-scope="scope">
          {{ scope.row.title }}
        </template>
      </el-table-column>

      <el-table-column label="分类" width="150" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.classTxt }}</span>
        </template>
      </el-table-column>

      <el-table-column label="广告图" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.headImg" style="width: 100%" />
        </template>
      </el-table-column>

      <el-table-column label="发布时间" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.dateNews }}</div>
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="状态" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status | statusFilter">{{
            scope.row.status === 2 ? '已发布' : '编辑中'
          }}</el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column class-name="status-col" label="添加人" width="160" align="center">
                <template slot-scope="scope">
                    {{ scope.row.creator }}
                </template>
            </el-table-column> -->

      <el-table-column label="操作" width="100" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            @click="onEditItem(scope)"
            v-if="roleList[path].includes('_Update')"
            >编辑</el-button
          >
          <el-button
            type="text"
            size="mini"
            @click="onDeleteItem(scope)"
            v-if="roleList[path].includes('_Delete')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- </div> -->
    <!-- 分页 -->
    <Pagination ref="Pagination" />
    <!-- 修改表单对话框 -->
    <editNews ref="editNews" />
  </div>
</template>

<script>
// import { getList } from '@/api/table'
import Pagination from '@/components/Pagination';
import { newsList, newsRemove } from '@/api/newsApi.js';
const editNews = () => import('./editNews');
import { mapGetters } from 'vuex';
//var that;
export default {
  components: {
    Pagination,
    editNews,
  },

  data() {
    return {
      tableData: [],
      listLoading: false,
      pageIndex: 1,
      pageSize: 10,
      path: '',
      multipleSelection: [],
      formInline: {
        title: '',
        classType: 0,
        status: '',
      },
      checkList: [],
    };
  },
  computed: {
    ...mapGetters(['paginObj', 'roleList']),
  },
  beforeCreate() {
    //that = this;
  },
  created() {
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
  },
  mounted() {
    this.getList();
  },
  inject: ['reload'],
  filters: {
    statusFilter(status) {
      const statusMap = {
        draft: 'gray',
        published: 'success',
        deleted: 'danger',
      };
      return statusMap[status];
    },
  },

  watch: {
    paginObj: 'getList',
  },
  methods: {
    // 获取数据的方法
    getList() {
      try {
        this.listLoading = true;
        const areaId = localStorage.getItem('areaId')
          ? JSON.parse(localStorage.getItem('areaId')).areaId
          : '';
        newsList({
          pageSize: this.paginObj.pageSize,
          pageIndex: this.paginObj.pageIndex,
          title: this.formInline.title,
          classType: this.formInline.classType,
          status: this.formInline.status,
          areaId,
        }).then((res) => {
          let { pageSize, pageIndex, dataList, totalCount } = res.data;
          if (dataList)
            this.tableData = dataList.sort((a, b) => a.dateNews - b.dateNews);
          this.pageIndex = pageIndex;
          this.pageSize = pageSize;
          this.listLoading = false;
          this.$refs.Pagination.pageSize = pageSize;
          this.$refs.Pagination.pageIndex = pageIndex;
          this.$refs.Pagination.totalCount = totalCount;
        });
      } catch (e) {
        window.console.log(e);
      }
    },
    // 选中
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.checkList = val.map((item) => {
        return item.newId;
      });
    },

    // 搜索
    onSearch() {
      this.getList();
    },
    // 刷新当前页面
    onRefresh() {
      this.reload();
    },
    // 增加
    onAdd() {
      this.$refs.editNews.adId = '';
      this.$refs.editNews.dialogTitle = '新增新闻';
      this.$refs.editNews.resetFrom();
      this.$refs.editNews.editForm.headImg = null;
      this.$refs.editNews.dialogFormVisible = true;
    },
    // 单条编辑
    onEditItem(scope) {
      this.currentRow = scope.row;
      // window.console.log(scope.row)
      this.$refs.editNews.newId = scope.row.newId;
      this.$refs.editNews.dialogTitle = '编辑新闻';
      this.$refs.editNews.dialogFormVisible = true;
      this.$refs.editNews.editData = JSON.parse(JSON.stringify(scope.row));
    },
    // 勾选编辑
    onEdit() {
      if (this.multipleSelection.length === 0)
        return this.$message.error('请选择要编辑的数据');
      if (this.multipleSelection.length > 1)
        return this.$message.error('请选择要编辑的单条数据');
      this.$refs.editNews.dialogFormVisible = true;
      this.$refs.editNews.editData = JSON.parse(
        JSON.stringify(this.multipleSelection)
      );
    },
    // 勾选删除
    onRemove() {
      console.log(this.multipleSelection, '待删除数据');
      if (this.multipleSelection.length === 0)
        return this.$message.error('请选择要删除的数据');
      const idList = this.multipleSelection.map((item) => {
        return item.newId;
      });
      this.funcRemove(idList);
    },
    // 单条删除
    onDeleteItem(scope) {
      const idList = [scope.row.newId];
      this.funcRemove(idList);
    },
    funcRemove(idList) {
      try {
        if (idList.length === 0)
          return this.$message.error('请选择要删除的数据');
        this.$confirm('是否狠心删除该数据', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error',
        })
          .then(async () => {
            await newsRemove({ idList }).then((res) => {
              if (res.code === 200) {
                this.onRefresh();
                this.$message.success('删除成功!');
              } else {
                this.$message.info('删除失败：' + res.message);
              }
            });
          })
          .catch(() => {
            this.$message.info('删除出错');
          });
      } catch (e) {
        this.$message.info('删除出错:' + e.message);
        window.console.log(e);
      }
    },
    onGoto() {},
    onChange() {},
  },
};
</script>

<style lang="less" scoped>
.app-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  // height: 60px;
  .search {
    display: flex;
    width: 800px;

    .search-input {
      margin: 0 10px;
      width: 300px;
    }

    .search-picker {
      width: 250px;
    }

    .search-select {
      margin-right: 10px;
    }
  }

  button {
    height: 40px;
  }
}

.content {
  flex: 1;
  overflow-y: scroll;
}
.btn {
  display: flex;
  align-items: center;
}
/deep/ .el-checkbox__input {
  margin-left: 10px;
}
</style>
